import React from 'react'
import CodePlagImg from "../../assets/plagiarised.png"
import RetinexImg from "../../assets/retinex.png"
import EyeGazeImg from "../../assets/eye_gaze.png"
import BCentralImg from "../../assets/Graph_betweenness.png"
import GruImg from "../../assets/GRU.png"
import TSAImg from "../../assets/twitter.png"
import MedRevImg from "../../assets/medrev.png"
import HoppitImg from "../../assets/hoppit.jpeg"
import CodeshareImg from "../../assets/codeshare.png"
import { FaGithub } from "react-icons/fa";

import "./styles.css"

const data =[
  {
    id:1,
    image: CodePlagImg,
    title: "Code Plagiarism Detection using Blockchain",
    github: "https://github.com/harsh2338/code-copyright",
    text:[
      "Preprocessed code files for multiple languages with the Abstract Syntax Trees generated by ANTLR.",
      "Developed smart contracts using Solidity for a local Ethereum network with nodes configured using Geth.",
      "Extended IPFS to allow permissioned access to files using Go implementation of IPFS.\n",
      "",
      ""
    ]
  },
  {
    id:2,
    image: EyeGazeImg,
    title: "Eye Gaze Controlled Virtual Keyboard",
    github: "https://github.com/harsh2338/Eye-Gaze-Controlled-Virtual-Keyboard",
    text:[
      "Application developed using OpenCV in Python to type words from a virtual keyboard using the human eye.",
      "Optimized various features to improve the CPM by 63% when compared to traditional QWERTY keyboard.",
      "",
      ""
    ]
  },
  {
    id:3,
    image: TSAImg,
    title: "Twitter Sentiment Analysis",
    github: "https://github.com/harsh2338/Twitter-Analysis",
    text:[
      "A Web Application built using Angular and Node.js for analysis of Tweets",
      "Provides the sentiment analysis of tweets of a particular hashtag.",
      "Retrieves live tweets for a subscribed hashtag and provides live analysis of the tweets.",
      "",
      ""
    ]
  },


  {
    id:4,
    image: MedRevImg,
    title: "Medicine Review System",
    github: "https://github.com/harsh2338/DBS-Medicine-Review",
    text:[
      "A Web Application built using Vue and Node.js for providing a medium to give reviews on medicines and possible alternatives",
      "Designed the database schema with optimal Normalisation and required Queries.",
      "",
      ""
    ]
  },

  {
    id:5,
    image: CodeshareImg,
    title: "Real Time Collaborative Code Editor",
    github: "https://github.com/harsh2338/codeshare",
    text:[
      "Worked on a real-time collaborative code editor which maintains commutativity and idempotency using CRDT.",
      "Implemented multiple cursors and handled multiple connected users using Phoenix Presence.",
      "",
      ""
    ]
  },
  {
    id:6,
    image: BCentralImg,
    title: "Parallelising Betweenness Centrality using Brande's Algorithm with CUDA",
    github: "https://github.com/harsh2338/Betweenness-Centrality-Cuda",
    text:[
      "Graphs that model COVID-19 transmission, social networks, and the structure of the internet are enormous and cannot be manually inspected.",
      "Betweenness Centrality can be used to analyze these graphs but the fastest algorithm to calculate this runs in quadratic time",
      "Therefore for faster calculation the algorithm was parallelised <br>using CUDA."
      ,"",
      ""
    ]
  },

  {
    id:7,
    image: RetinexImg,
    title: "Low Light Image Enhancement Guided by Reference Images",
    text:[
      "Implemented a Deep Retinex Net model using Pytorch that enhances low light images.",
      "Enhanced images using techniques inspired by Neural Style transfer and provided results with an average SSIM score of 80%",
      "",
      ""
    ],
  },
  
  {
    id:8,
    image: HoppitImg,
    title: "Hoppit (Freelance Project)",
    text:[
      "Android app developed using Flutter to find fashion brands and stores near your location.",
      "Translated designs and wireframes into code following Bloc State Management",
      "",
      ""
    ]
  },
  {
    id:9,
    image: GruImg,
    title: "API Injection Detection using RNNs",
    text:[
      "Evaluated sequence models to identify SQL, XML, JSON and other types of malicious injections in an API request.",
      "Compared Vanilla RNN, LSTM, GRU and their corresponding bidirectional versions.",
      "",
      ""
    ]
  },

]
const Portfolio = () => {
  return (
    <section id="projects">
      <h2>Projects</h2>
      <div className="container portfolio__container">
      {
        data.map(({id,image,title, github, demo,text})=>{
          return (
            <article className="portfolio__item">
              <div className="portfolio__item-image">
                  <img src={image} alt="" />
              </div>
              <h3 className='portfolio__title'>{title}</h3>

              <ul>
              {
                text.map((val)=>{
                  if(val==="")
                  return <br></br>
                  return(
                      <li className='portfolio__list-item'> &#8226; {val}</li>
                  )
                })
              }
               </ul>
               {github?<a href={github} className="btn code-btn" target='_blank' rel="noreferrer">Code</a>:<div></div>}
            </article> 
          )
        })
      }
      </div>
    </section>
  )
}

export default Portfolio

// \cvevent{\large \textbf {\hrefa{https://github.com/harsh2338/RNN-API-injections}{API Injection Detection using RNNs}}}{}{}{}
// \begin{itemize}
// \item \normalsize Evaluated sequence models to identify SQL, XML, JSON and other types of malicious injections in an API request.
// \item \normalsize Compared Vanilla RNN, LSTM, GRU and their \\corresponding bidirectional versions.
// \end{itemize}


// \smallbreak
// \cvevent{\large \textbf {\hrefa{https://github.com/harsh2338/codeshare}{Real Time Collaborative Code Editor}}}{}{}{}
// \begin{itemize}

// \item \normalsize Worked on a real-time collaborative code editor which maintains commutativity and idempotency \linebreak using CRDT.
// \item \normalsize Implemented multiple cursors and handled multiple connected users using Phoenix Presence.

// \end{itemize}